module.exports = __webpack_public_path__ + "images/0534a3f092a20b52f24710a6715f8887.png";